import angular from 'angular';

export default function EditDocumentAttachmentDialogController(
  $q,
  $scope,
  $rootScope,
  alerts,
  pmDataService,
  ssDialogService,
  loaderService
) {
  const vm = this;

  vm.newAttachment = angular.copy(vm.attachment);
  vm.documentPresent = true;
  vm.attachmentType = vm.attachmentType || 'supportingDocument';
  vm.isEdit = vm.newAttachment.policyDocumentSupportingDocumentId > 0 || vm.newAttachment.policyDocumentAddendaId;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleDocumentAttachmentFileAdd = _handleDocumentAttachmentFileAdd;
  vm.handleEditDocumentAttachmentFormSubmit = _handleEditDocumentAttachmentFormSubmit;

  function _handleCloseDialog() {
    _closeDialog();
  }

  // eslint-disable-next-line no-unused-vars
  function _handleDocumentAttachmentFileAdd($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    vm.selectedFile = $file;
    vm.documentPresent = true;
    // console.log($files);
    // console.log($file);
    // console.log($newFiles);
    // console.log($duplicateFiles);
    // console.log($invalidFiles);
    // console.log($event);
  }
  function _handleEditDocumentAttachmentFormSubmit() {
    loaderService.showViewLoader = true;
    if (_isValid()) {
      // const justEditMetadata = vm.isEdit && !vm.newAttachment.file;
      const dfdSave = $q.defer();
      if (vm.attachmentType === 'supportingDocument') {
        _addUpdateSupportingDocument(dfdSave);
      } else if (vm.attachmentType === 'addendum') {
        // Just editing metadata, no upload needed
        _addUpdateDocumentAddendum(dfdSave);
      }

      dfdSave.promise.then(() => {
        alerts.success('The Document Attachment has been saved successfully.');
        $rootScope.$broadcast('refreshPMDocumentAttachments',
          { policyDocumentId: vm.document.policyDocumentId });
        _closeDialog();
      })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
    loaderService.showViewLoader = false;
  }

  function _addUpdateDocumentAddendum(dfdSave) {
    const policyDocumentId = vm.document.policyDocumentId;
    const displayName = vm.newAttachment.name;
    let fileName = '';
    const justEditMetadata = vm.isEdit && !vm.newAttachment.file;

    if (vm.selectedFile) {
      fileName = vm.newAttachment.file.name;
    } else if (justEditMetadata) {
      // When we update the Display Name, the server will try to change the file name to match the displayName.
      fileName = displayName + vm.document.extension;
    }

    let policyDocumentAddendaId = -1;
    if (vm.attachment.policyDocumentAddendaId !== undefined) {
      policyDocumentAddendaId = vm.attachment.policyDocumentAddendaId;
    }

    const promises = [
      pmDataService.checkDocumentAddendumDisplayNameExists(policyDocumentId, policyDocumentAddendaId, displayName),
    ];

    if (fileName) {
      // eslint-disable-next-line max-len
      promises.push(pmDataService.checkDocumentAddendumFileNameExists(policyDocumentId, policyDocumentAddendaId, fileName));
    }

    $q.all(promises).then((response) => {
      const displayNameExists = response[0].data.result;
      let fileNameExists = false;
      if (fileName) {
        // eslint-disable-next-line no-const-assign
        fileNameExists = response[1].data.result;
      }

      if (displayNameExists) {
        $scope.editDocumentAttachmentForm.documentAttachmentName.$invalid = true;
        $scope.editDocumentAttachmentForm.documentAttachmentName.$error = { duplicate: true };
        vm.isValid = false;
        // eslint-disable-next-line max-len
        alerts.error('There is currently an Addendum that uses the selected Name. Please choose a different Name.');
      } else {
        $scope.editDocumentAttachmentForm.documentAttachmentName.$invalid = false;
        $scope.editDocumentAttachmentForm.documentAttachmentName.$error = '';
      }

      if (fileNameExists) {
        vm.fileNameIsInvalid = true;
        vm.isValid = false;
        // eslint-disable-next-line max-len
        alerts.error('There is currently an Addendum that uses the same File Name. Please use a Document with a different File Name.');
      } else {
        vm.fileNameIsInvalid = false;
      }

      if ((!displayNameExists) && (!fileNameExists)) {
        if (justEditMetadata) {
          // Just editing metadata, no upload needed
          pmDataService.updateDocumentAddendum(vm.newAttachment)
            .then(dfdSave.resolve)
            .finally(() => {
              loaderService.showViewLoader = false;
            });
        } else {
          // New file is supporting document
          pmDataService.uploadDocumentAddendum(vm.document.policyDocumentId, vm.newAttachment)
            .then(dfdSave.resolve)
            .finally(() => {
              loaderService.showViewLoader = false;
            });
        }
      }
    });
  }
  function _addUpdateSupportingDocument(dfdSave) {
      const policyDocumentId = vm.document.policyDocumentId;
      const displayName = vm.newAttachment.name;
      let fileName = '';
      const justEditMetadata = vm.isEdit && !vm.newAttachment.file;

      if (vm.selectedFile) {
        fileName = vm.newAttachment.file.name;
      }

      let policyDocumentSupportingDocumentId = -1;
      if (vm.attachment.policyDocumentSupportingDocumentId !== undefined) {
        policyDocumentSupportingDocumentId = vm.attachment.policyDocumentSupportingDocumentId;
      }

      const promises = [
        // eslint-disable-next-line max-len
        pmDataService.checkSupportingDocumentDisplayNameExists(policyDocumentId, policyDocumentSupportingDocumentId, displayName),
      ];

      if (fileName) {
        // eslint-disable-next-line max-len
        promises.push(pmDataService.checkSupportingDocumentFileNameExists(policyDocumentId, policyDocumentSupportingDocumentId, fileName));
      }

      $q.all(promises).then((response) => {
        const displayNameExists = response[0].data.result;
        let fileNameExists = false;
        if (fileName) {
          // eslint-disable-next-line no-const-assign
          fileNameExists = response[1].data.result;
        }

        if (displayNameExists) {
          $scope.editDocumentAttachmentForm.documentAttachmentName.$invalid = true;
          $scope.editDocumentAttachmentForm.documentAttachmentName.$error = { duplicate: true };
          vm.isValid = false;
          // eslint-disable-next-line max-len
          alerts.error('There is currently a Supporting Document that uses the selected Name. Please choose a different Name.');
        } else {
          $scope.editDocumentAttachmentForm.documentAttachmentName.$invalid = false;
          $scope.editDocumentAttachmentForm.documentAttachmentName.$error = '';
        }

        if (fileNameExists) {
          vm.fileNameIsInvalid = true;
          vm.isValid = false;
          // eslint-disable-next-line max-len
          alerts.error('There is currently a Supporting Document that uses the same File Name. Please use a Document with a different File Name.');
        } else {
          vm.fileNameIsInvalid = false;
        }

        if ((!displayNameExists) && (!fileNameExists)) {
          if (justEditMetadata) {
            // Just editing metadata, no upload needed
            pmDataService.updateDocumentSupportingDocument(vm.newAttachment)
              .then(dfdSave.resolve)
              .finally(() => {
                loaderService.showViewLoader = false;
              });
          } else {
            // New file is supporting document
            pmDataService.uploadDocumentSupportingDocument(vm.document.policyDocumentId, vm.newAttachment)
              .then(dfdSave.resolve)
              .finally(() => {
                loaderService.showViewLoader = false;
              });
          }
        }
      });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.pm.editDocumentAttachmentDialog);
  }

  function _isValid() {
    let isValid = true;
    if (vm.newAttachment.file || vm.newAttachment.documentId) {
      vm.documentPresent = true;
    } else {
      isValid = false;
      vm.documentPresent = false;
    }

    if ($scope.editDocumentAttachmentForm.$invalid) {
      isValid = false;
    }

    return isValid;
  }
}

EditDocumentAttachmentDialogController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'pmDataService',
  'ssDialogService',
  'loaderService'
];
